import * as React from 'react';
import ReactHotToast from 'react-hot-toast';

import type { AttachmentType } from '@/features/ChatBotV2/types';
import { useFetchUploadConfig } from '@/hooks/useFetchUploadConfig';

import { useUploadAndProcessAttachments } from './useUploadAndProcessAttachments';

export const useHandleFilesDrop = (
  attachmemntsFeedId?: string,
  attachments?: AttachmentType[]
) => {
  const { uploadAndProcessAttachments } = useUploadAndProcessAttachments();
  const { data: uploadConfig } = useFetchUploadConfig({
    source: 'ask_needl',
  });

  const handleFilesDrop = React.useCallback(
    (files: File[]) => {
      if (
        files.length + (attachments?.length || 0) >
        (uploadConfig?.file_count_limit ?? 0)
      ) {
        ReactHotToast.error(
          `You can only upload ${
            uploadConfig?.file_count_limit ?? 0
          } files at a time`
        );
        return;
      }
      uploadAndProcessAttachments(files, attachmemntsFeedId);
    },
    [attachmemntsFeedId, attachments, uploadAndProcessAttachments, uploadConfig]
  );

  return {
    handleFilesDrop,
  };
};
